import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authenticationService.isAuthenticated()) {
      this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const roles = route.data['roles'] as number[] | undefined;
    const superAdminOnly = route.data['superAdminOnly'] === true;

    if (superAdminOnly && !this.authenticationService.isSuperAdmin()) {
      this.router.navigate(['/filemanager/principal']);
      return false;
    }

    if (roles?.length && !this.authenticationService.hasRole(roles)) {
      this.router.navigate(['/filemanager/principal']);
      return false;
    }

    return true;
  }
}
